import axios from 'axios';
import { convertUtcDate } from '../components/Common/cleanDates';

import {
  REQUEST_PRE_ORDERS,
  FETCH_PRE_ORDERS_SUCCESS,
  FETCH_PRE_ORDERS_FAILURE,
  SELECT_SALES_ORDER,
  RESET_CURRENT_SALES_ORDER,
  REQUEST_SALES_ORDER_DETAIL,
  FETCH_SALES_ORDER_DETAIL_SUCCESS,
  FETCH_SALES_ORDER_DETAIL_FAILURE,
} from './type';

import {
  SALES_ORDERS_URL,
  MOBILE_SALES_ORDERS_URL,
  SALE_PRE_ORDER_SEARCH_URL,
} from './url';

import { ROOT_URL, ROOT_API_URL } from './root_url';

import { DEFAULT_ERROR } from '../components/Common/constants';

export function requestPreOrders() {
  return {
    type: REQUEST_PRE_ORDERS,
  };
}

export function fetchPreOrdersSuccess(preOrders) {
  return {
    type: FETCH_PRE_ORDERS_SUCCESS,
    payload: preOrders,
  };
}

export function fetchPreOrdersFailure(error) {
  return {
    type: FETCH_PRE_ORDERS_FAILURE,
    payload: error,
  };
}

export function fetchPreOrders() {
  return (dispatch) => {
    dispatch(requestPreOrders());
    return axios.get(
      SALE_PRE_ORDER_SEARCH_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPreOrdersFailure(err));
      });
  };
}

export function selectSalesOrder(salesOrder) {
  return {
    type: SELECT_SALES_ORDER,
    payload: salesOrder,
  };
}


export function resetCurrentSalesOrder() {
  return {
    type: RESET_CURRENT_SALES_ORDER,
  };
}

// Fetch the detail page.
export function fetchSalesOrderDetail(salesOrder_id, route) {
  const url = (route == 'salesOrders') ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  return (dispatch) => {
    dispatch(requestSalesOrderDetail());
    return axios.get(
      `${url}?pk=${salesOrder_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderDetailFailure(err));
      });
  };
}

export function requestSalesOrderDetail() {
  return {
    type: REQUEST_SALES_ORDER_DETAIL,
  };
}


export function fetchSalesOrderDetailSuccess(salesOrderDetail) {
  salesOrderDetail = salesOrderDetail.data;
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = convertUtcDate(salesOrderDetail.OrderDate);
  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = convertUtcDate(salesOrderDetail.ETADate);
  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = convertUtcDate(salesOrderDetail.ReceivedDate);
  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = convertUtcDate(salesOrderDetail.DispatchDate);
  return {
    type: FETCH_SALES_ORDER_DETAIL_SUCCESS,
    payload: salesOrderDetail,
  };
}

export function fetchSalesOrderDetailFailure(error) {
  return {
    type: FETCH_SALES_ORDER_DETAIL_FAILURE,
    payload: error,
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/preOrders_actions.js